var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnectedChains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.831,
    height: 11.186,
    viewBox: "0 0 12.831 11.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -30.318)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 30.318)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.549,37.328a2.2,2.2,0,0,0-3-.843L5.412,38.808l.476.849,4.139-2.323a1.229,1.229,0,0,1,1.2,2.143L7.478,41.582a2.187,2.187,0,0,0-.618-1.213,2.254,2.254,0,0,0-2.3-.514l-.339.122.329.915.34-.121a1.254,1.254,0,0,1,1.286.287,1.221,1.221,0,0,1,.347.689l-.047-.012a1.22,1.22,0,0,1-.74-.583l-.177-.312-.849.477.178.312a2.185,2.185,0,0,0,1.325,1.043l.059.015a1.241,1.241,0,0,1-.1.108l-3.1,3.1a1.229,1.229,0,0,1-1.738-1.737l2.694-2.693-.688-.688L.645,43.471a2.2,2.2,0,0,0,3.114,3.114l3.1-3.1a2.207,2.207,0,0,0,.511-.806,2.174,2.174,0,0,0,.509-.206l3.825-2.146a2.2,2.2,0,0,0,.842-3Z",
    transform: "translate(0 -36.204)",
    fill: "#326483"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.968 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.983,33.341a.226.226,0,0,0,.181-.262L146.7,30.5a.226.226,0,1,0-.444.08l.464,2.575A.226.226,0,0,0,146.983,33.341Z",
    transform: "translate(-146.252 -30.318)",
    fill: "#326483"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.916 3.468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.043,159.056l2.575-.464a.226.226,0,0,0-.08-.444l-2.576.465a.226.226,0,0,0,.08.444Z",
    transform: "translate(-33.777 -158.143)",
    fill: "#326483"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectedChains);
export default __webpack_public_path__ + "static/media/disconnected-chains.cf30db8cab47f5ce6a4bf87b280f4924.svg";
export { ForwardRef as ReactComponent };